import { useBulkFetchTimelineItems } from '@/lib/queries/loop-planner/useBulkFetchTimelineItems';
import type { PlanSchedulingScenarioContext } from '../adapters/types';
import { useSchedulesQueryWithPublished } from './useSchedulesQueryWithPublished';

interface ScheduleBarData {
  expectedStart: string | undefined;
  expectedFinish: string | undefined;
  latestFinish: string | undefined;
  isLoading: boolean;
}

export const useScheduleBarData = (
  itemId: number,
  scenarioContext?: PlanSchedulingScenarioContext,
): ScheduleBarData => {
  const { data: timelineItems, isLoading: isTimelineLoading } = useBulkFetchTimelineItems({
    loopId: scenarioContext?.loopId ?? 0,
    scenarioId: scenarioContext?.scenarioId ?? 0,
    itemIds: scenarioContext ? [itemId] : [],
  });

  const { data: schedulesData, isLoading: isScheduleLoading } = useSchedulesQueryWithPublished(
    itemId,
    !scenarioContext,
  );

  if (scenarioContext) {
    const metrics = timelineItems?.find((t) => t.item.itemId === itemId)?.scenarioItemMetrics;
    return {
      expectedStart: metrics?.expectedStart ?? undefined,
      expectedFinish: metrics?.expectedFinish ?? undefined,
      latestFinish: metrics?.latestFinishDate ?? undefined,
      isLoading: isTimelineLoading,
    };
  }

  const schedule = schedulesData?.[itemId];
  return {
    expectedStart: schedule?.expectedStartDateTime ?? undefined,
    expectedFinish: schedule?.expectedFinishDateTime ?? undefined,
    latestFinish: schedule?.latestFinishDateTime ?? undefined,
    isLoading: isScheduleLoading,
  };
};
